import { render, staticRenderFns } from "./SimpleCheckbox.vue?vue&type=template&id=1c1c7c42&scoped=true"
import script from "./SimpleCheckbox.vue?vue&type=script&lang=js"
export * from "./SimpleCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1c7c42",
  null
  
)

export default component.exports